import { db } from "../firebase";
import {doc, getDoc } from "firebase/firestore";

export const fetchAuthorName = async (uid) => {
    try {
        const userRef = doc(db, "users", uid);
        const docSnap = await getDoc(userRef); // Await the result
        if (docSnap.exists()) {
            return docSnap.data().authorName;
        } else {
            console.error("Document does not exist");
            return null;
        }
    } catch (err) {
        console.error("Error fetching Author name: ", err);
        return null;
    }
}